module.exports = __webpack_public_path__ + "Flag-72.f4f7eccc82db507d43ea6cbea866590a.svg";